const constants = {
  base_api: process.env.REACT_APP_SERVER_URL,
};
export default constants;
